import template from './radioField.html';
import controller from '../field.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    fieldResponse: '<',
    onUpdate: '&',
  }
};

export default component;
